import { type FieldValues } from '@restore/dynamic-forms';

export const parseJotformDates = (fieldValues: FieldValues, dateFields: string[]): FieldValues => {
  let parsedFieldValues = { ...fieldValues };

  for (const [key, value] of Object.entries(fieldValues)) {
    if (dateFields.includes(key)) {
      const newFields: { [key: string]: string } = {};
      const date = new Date(value);

      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();

      newFields[`${key}~day`] = (day < 10 ? '0' : '') + day.toString();
      newFields[`${key}~month`] = (month < 10 ? '0' : '') + month.toString();
      newFields[`${key}~year`] = year.toString();

      delete parsedFieldValues[key];
      parsedFieldValues = {
        ...parsedFieldValues,
        ...newFields,
      };
    }
  }

  return parsedFieldValues;
};
